import { z } from 'zod';

import { responsiveBooleanSchema, responsiveSchema } from '../../utils';

/**
 * One contour side. Legacy stored twelve flat `border*` keys per device bag;
 * v0 groups them by the side they draw.
 */
export const borderSideV0Schema = z.object({
    width: z.coerce.number().default(0),
    style: z.string().default('solid'),
    color: z.string().default(''),
});

export const borderV0Schema = z.object({
    version: z.literal(0),
    /** `isBorder` — with no contour the sides are not read at all. */
    isEnabled: responsiveBooleanSchema,
    /**
     * Legacy's `isIndependentBorders` is **not** here. It said whether the four
     * sides are edited separately, which the sides themselves already say: the
     * contour control writes all four on every edit and copies the top one
     * across when the switch goes off, so four equal sides *is* the shared
     * contour. A stored flag could only ever disagree with what it describes —
     * see {@link isBorderIndependent}, which derives it at read time.
     */
    //
    // The sides are absent while the contour is off at every breakpoint: they are
    // not read then, and switching it on seeds them (`createBorderSide`).
    top: responsiveSchema(borderSideV0Schema).optional(),
    right: responsiveSchema(borderSideV0Schema).optional(),
    bottom: responsiveSchema(borderSideV0Schema).optional(),
    left: responsiveSchema(borderSideV0Schema).optional(),
});
